export const focusRingTheme = {
   light: {
      Primary: {
         borderColor: 'border-primary-300',
         ringColor: 'ring-primary-100'
      },
      Destructive: {
         borderColor: 'border-error-600',
         ringColor: 'ring-error-100'
      },
      Gray: {
         borderColor: 'border-gray-300',
         ringColor: 'ring-gray-100'
      },
      Success: {
         borderColor: 'border-success-300',
         ringColor: 'ring-success-100'
      },
      Violet: {
         borderColor: 'border-violet-300',
         ringColor: 'ring-violet-100'
      },
      None: {
         borderColor: 'border-none',
         ringColor: 'ring-transparent'
      }
   },
   dark: {}
}
